import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUserPermissions } from "../features/authSlice";
import { hasPermission } from "../utils/authUtils";

export function ProtectedRoute({ element }) {
  const { isAuthenticated, token, user, isLoading } = useSelector(
    (state) => state.auth,
  );
  const location = useLocation();

  const hasStoredToken = Boolean(sessionStorage.getItem("authToken"));
  // If we have a stored session and we are validating it, don"t redirect yet.
  if (hasStoredToken && !isAuthenticated && isLoading) {
    return null;
  }

  if (!isAuthenticated || !token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user) {
    const isAdmin =
      Boolean(user.isAdmin) || Number.parseInt(user.usertype, 10) === 0;
    const dashboardPath = isAdmin ? "/AdminDashboard" : "/EmployeeDashboard";

    // Prevent cross-dashboard access
    if (location.pathname.startsWith("/AdminDashboard") && !isAdmin) {
      return <Navigate to={dashboardPath} replace />;
    }
    if (location.pathname.startsWith("/EmployeeDashboard") && isAdmin) {
      return <Navigate to={dashboardPath} replace />;
    }
  }

  return element;
}

export function PublicRoute({ element }) {
  const { isAuthenticated, user, isLoading } = useSelector(
    (state) => state.auth,
  );
  const hasStoredToken = Boolean(sessionStorage.getItem("authToken"));
  // If we have a stored session and we are validating it, don"t show public page yet.
  if (hasStoredToken && !isAuthenticated && isLoading) {
    return null;
  }
  if (isAuthenticated && user) {
    const dashboardPath = user.isAdmin
      ? "/AdminDashboard"
      : "/EmployeeDashboard";
    return <Navigate to={dashboardPath} replace />;
  }
  return element;
}
export function PermissionProtectedRoute({ element, requiredPermission }) {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const permissions = useSelector(selectUserPermissions);
  const location = useLocation();
  const hasPerm =
    user?.isAdmin || hasPermission(permissions, requiredPermission);
  if (!isAuthenticated || !hasPerm) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }
  return element;
}
